import { PerfilMenuModel,DataPerfilMenuModel }
from '../models/configuration/perfil-menu.model';
import { DataPerfilModel, PerfilModel }
from '../models/configuration/perfil.model';
import { DataMenuModel, MenuModel }
from '../models/configuration/menu.model';
import { ChannelSendModel, DataChannelSendModel }
from '../models/configuration/channel-send.model';
import { DataFileDocumentsSystemModel, FileDocumentsSystemModel } from '../models/configuration/file-documents-system.model';
import { Observable } from 'rxjs';
import { CountryModel } from '../models/configuration/country.model';
import { TypeDocumentModel } from '../models/configuration/type-document.model';
import {
  DataTypeCanalModel,
  TypeCanalModel,
} from '../models/configuration/type-canal.model';
import { CityModel } from '../models/configuration/city.model';
import { CanalModel } from '../models/configuration/canal.model';
import { StateProspectModel } from '../models/configuration/state-prospect.model';
import { TypeBloodModel } from '../models/configuration/type-blood';
import { CompanyModel } from '../models/configuration/company/company.model';
import { ConsultancyModel } from '../models/configuration/company/consultancy.model';
import { TypeServiceModel } from '../models/configuration/company/type-service.model';
import { ServiceModel } from '../models/configuration/company/service.model';
import { CollaboratorModel, DataCollaboratorModel } from '../models/configuration/company/collaborator.model';
import { GenderModel } from '../models/configuration/gender.model';
import { EPSModel } from '../models/configuration/eps.model';
import { RelationShipModel } from '../models/configuration/relationship.model';
import { StateCivilModel } from '../models/configuration/state-civil.model';
import { PrepaidMedicineModel } from '../models/configuration/prepaid-medicinal.model';
import { DiagnosticModel } from '../models/configuration/diagnostic.model';
import { RevisionModel } from '../models/configuration/revision.model';
import { DepartamentModel } from '../models/configuration/departament.model';
import { StateProspectFollowupModel } from '../models/configuration/state-prospect-followup.model';
import { LocationModel } from '../models/configuration/location.model';
import { TypeInvoiceModel } from '../models/configuration/type-invoice.model';
import { InvoiceModel } from '../models/configuration/invoice.model';
import { InvoiceResponseModel } from '../models/configuration/invoice-response.model';
import { ProfessionalModel } from '../models/configuration/professional.model';
import { PendingInvoiceReportEntity } from '../../data/repositories/configuration/entities/pending-invoice-report.entity';
import {
  ConsentModel,
  DataConsentModel,
} from '../models/configuration/consent.model';
import { OrganizationModel } from '../models/configuration/type-organization.model';
import { ConvenioModel } from '../models/configuration/convenio.model';
import { MetodoPagoSaludModel } from '../models/configuration/metodo-pago-salud.model';
import { TipoPlanSaludModel } from '../models/configuration/tipo-plan-salud.model';
import { MetodoPagoFinancieroModel } from '../models/configuration/metodo-pago-financiero.model';
import {
  DataThirdCompanyModel,
  ThirdCompanyResponseModel,
} from '../models/configuration/company/third-company.model';
import { OrganizationTypeInvoiceRIPSModel } from '../models/configuration/organization-type-invoice-rips.model';
import { EnablingCodeModel } from '../models/configuration/enabling-code.model';
import {
  BusinessModel,
  DataBusinessModel,
} from '../models/configuration/company/business.model';
import { TypeBusinessModel } from '../models/configuration/company/type-business.model';
import { ComercialModel } from '../models/comercial/comercial.model';
import { ChargeModel } from '../models/configuration/charge.model';
import {
  DataDemoBusinessModel,
  DemoBusinessModel,
} from '../models/configuration/company/demo-business.model';
import { DataHeadquartersModel, HeadquartersModel } from '../models/configuration/company/headquarters.model';
import { DataOfficesModel, OfficesModel } from '../models/configuration/company/offices.model';
import { StateCollaboratorModel } from '../models/configuration/company/state-collaborator.model';
import { DataCollaboratorPositionEntity } from '../../data/repositories/configuration/entities/company/collaboratorPosition.entity';
import { CollaboratorPositionModel } from '../models/configuration/company/collaboratorposition.model';
import { PlanBusinessModel } from '../models/configuration/company/plan-business.model';
import { DataDocumentsSystemModel, DocumentsSystemModel } from '../models/configuration/documents-system.model';
import { InvoiceRIPSConfigurationModel } from '../models/configuration/invoice-rips-configuration.model';
import { DataInvoiceRIPSConfigurationModel } from '../models/configuration/invoice-rips-configuration.model';
import { DataScheduleProfessionalModel, ScheduleProfessionalModel } from '../models/configuration/schedule-professional.model';

export abstract class ConfigurationRepository {
  abstract getTypeDocument(params: {
    idCountry: string;
  }): Observable<TypeDocumentModel>;
  abstract getCity(params: { id: string }): Observable<CityModel>;
  abstract getDepartament(params: { id: string }): Observable<DepartamentModel>;
  abstract getLocation(params: { id: string }): Observable<LocationModel>;
  abstract getCanal(params: { idTypeCanal: string }): Observable<CanalModel>;
  abstract getCountry(): Observable<CountryModel>;
  abstract getCharge(): Observable<ChargeModel>;
  abstract getTypeService(): Observable<TypeServiceModel>;
  abstract getService(params: {
    idTipoServicio: string;
  }): Observable<ServiceModel>;
  abstract getServiceByCompanyid(): Observable<ServiceModel>;
  abstract getUsers(): Observable<ComercialModel>;
  abstract getEnablingsCode(): Observable<EnablingCodeModel>;
  abstract getMetodoPagoSalud(): Observable<MetodoPagoSaludModel>;
  abstract getMetodoPagoFinanciero(): Observable<MetodoPagoFinancieroModel>;
  abstract getTipoPlanSalud(): Observable<TipoPlanSaludModel>;
  abstract getTypeOrganization(): Observable<OrganizationModel>;
  abstract getOrganizationTypeInvoiceRIPS(): Observable<OrganizationTypeInvoiceRIPSModel>;
  abstract getStateProspect(): Observable<StateProspectModel>;
  abstract getStateProspectFollowup(): Observable<StateProspectFollowupModel>;
  abstract getTypeBlood(): Observable<TypeBloodModel>;
  abstract getStateCivil(): Observable<StateCivilModel>;
  abstract getEPS(params: { idCountry: string }): Observable<EPSModel>;
  abstract getGender(): Observable<GenderModel>;
  abstract getRelationship(): Observable<RelationShipModel>;
  abstract getPrepaidMedicine(params: {
    idCountry: string;
  }): Observable<PrepaidMedicineModel>;
  abstract getAgreement(): Observable<CompanyModel>;
  abstract getDiagnostic(params: {
    idCountry: string;
  }): Observable<DiagnosticModel>;
  abstract getRevision(): Observable<RevisionModel>;
  abstract getFiscalResponsibility(): Observable<any>;

  /** Invoice RIPS Configuration */
  abstract getInvoiceRIPSConfigurationByCompany(): Observable<any>;
  abstract getInvoiceRIPSByCompanyIdAdmin(params: { idEmpresa: string }): Observable<InvoiceRIPSConfigurationModel>;
  abstract insertInvoiceRIPSByCompanyIdAdmin(params: DataInvoiceRIPSConfigurationModel): Observable<InvoiceRIPSConfigurationModel>;
  abstract updateInvoiceRIPSByCompanyIdAdmin(params: DataInvoiceRIPSConfigurationModel): Observable<InvoiceRIPSConfigurationModel>;
  abstract insertInvoiceRIPSConfiguration(params: any): Observable<any>;
  abstract updateInvoiceRIPSConfiguration(params: any): Observable<any>;

  /**Convenio */
  abstract getAllConveniosByEmpresa(): Observable<ConvenioModel>;
  abstract insertConvenio(params: DataConsentModel): Observable<ConvenioModel>;
  abstract updateConvenio(params: DataConsentModel): Observable<ConvenioModel>;
  abstract deleteConvenio(params: DataConsentModel): Observable<ConvenioModel>;

  /** Sedes */
  abstract getAllHeadquartersByBussines(): Observable<HeadquartersModel>;
  abstract getHeadquartersByCompanyid(params: { idServicio: string }): Observable<HeadquartersModel>;
  abstract getHeadquartersAllByCompanyIdAdmin(params: { idEmpresa: string }): Observable<HeadquartersModel>;
  abstract insertHeadquarters(params: DataHeadquartersModel): Observable<HeadquartersModel>;
  abstract insertHeadquartersAdmin(params: DataHeadquartersModel): Observable<HeadquartersModel>;
  abstract updateHeadquarters(params: DataHeadquartersModel): Observable<HeadquartersModel>;
  abstract updateHeadquartersAdmin(params: DataHeadquartersModel): Observable<HeadquartersModel>;
  abstract deleteHeadquarters(params: DataHeadquartersModel): Observable<HeadquartersModel>;

  /** Consultorio */
  abstract getAllOfficesByHeadquarters(params:{idSedeEmpresa:string}): Observable<OfficesModel>;
  abstract getOfficeByHeadquartersIdAdmin(params: { idSedeEmpresa: string }): Observable<OfficesModel>;
  abstract insertOffices(params: DataOfficesModel): Observable<OfficesModel>;
  abstract insertOfficesIdAdmin(params: DataOfficesModel): Observable<OfficesModel>;
  abstract updateOffices(params: DataOfficesModel): Observable<OfficesModel>;
  abstract updateOfficesIdAdmin(params: DataOfficesModel): Observable<OfficesModel>;
  abstract deleteOffices(params: DataOfficesModel): Observable<OfficesModel>;
  abstract deleteOfficesIdAdmin(params: { id: string }): Observable<OfficesModel>;

  /** Tipo de Canal */
  abstract getTypeCanal(): Observable<TypeCanalModel>;
  abstract insertTypeCanal(
    params: DataTypeCanalModel
  ): Observable<TypeCanalModel>;
  abstract updateTypeCanal(
    params: DataTypeCanalModel
  ): Observable<TypeCanalModel>;
  abstract deleteTypeCanal(params: { Id: string }): Observable<TypeCanalModel>;

  /** Empresas */
  abstract getCampusCompany(): Observable<CompanyModel>;
  abstract getConsultancyCompany(params: {
    IdCampus: string;
  }): Observable<ConsultancyModel>;
  abstract getTypeServiceCompany(params: {
    IdConsulting: string;
  }): Observable<TypeServiceModel>;
  abstract getServiceCompany(params: {
    IdTypeService: string;
  }): Observable<ServiceModel>;
  abstract getCollaboratorCompany(params: {
    IdService: string;
  }): Observable<CollaboratorModel>;
  abstract getProfesionalByCompanyid(params: {
    idSedeEmpresa: string;
    idServicioEmpresa: string;
  }): Observable<CollaboratorModel>;
  abstract getCollaboratorCompanyAll(): Observable<CollaboratorModel>;
  abstract getCollaboratorAllAdmin(
    params: { idEmpresa: string}
  ): Observable<CollaboratorModel>;
  abstract getStateCollaborator(): Observable<StateCollaboratorModel>;
  abstract insertCollaborator(params: DataCollaboratorModel): Observable<CollaboratorModel>;
  abstract insertCollaboratorAllAdmin(params: DataCollaboratorModel): Observable<CollaboratorModel>;
  abstract updateCollaborator(params: DataCollaboratorModel): Observable<CollaboratorModel>;
  abstract updateCollaboratorAllAdmin(params: DataCollaboratorModel): Observable<CollaboratorModel>;
  abstract getPlanBussines(): Observable<PlanBusinessModel>;
  abstract getPlanBussinesIdAdmin(params: { idEmpresa: string }): Observable<PlanBusinessModel>;
  /** Terceros */
  abstract insertThirdCompany(
    params: DataThirdCompanyModel
  ): Observable<ThirdCompanyResponseModel>;
  abstract getThirdCompany(params: {
    IdTipoDocumento: string;
    NumeroDocumento: string;
  }): Observable<ThirdCompanyResponseModel>;
  abstract getThirdCompanyAll(params: {
    IdEmpresa: string;
  }): Observable<ThirdCompanyResponseModel>;
  abstract getThirdCompanyById(params: {
    IdTerceroEmpresa: string;
  }): Observable<ThirdCompanyResponseModel>;
  abstract updateThirdCompany(
    params: DataThirdCompanyModel
  ): Observable<ThirdCompanyResponseModel>;
  abstract deleteThirdCompany(params: {
    Id: string;
  }): Observable<ThirdCompanyResponseModel>;

  /** Facturas */
  abstract getTypeInvoice(): Observable<TypeInvoiceModel>;
  abstract getInvoiceAll(
    params: InvoiceModel
  ): Observable<InvoiceResponseModel>;
  abstract getProfessional(): Observable<ProfessionalModel>;
  abstract insertInvoice(
    params: InvoiceModel
  ): Observable<InvoiceResponseModel>;
  abstract getInvoiceByDate(
    params: InvoiceModel
  ): Observable<PendingInvoiceReportEntity>;

  /** Consentimiento */
  abstract getConsent(): Observable<ConsentModel>;
  abstract insertConsent(params: DataConsentModel): Observable<ConsentModel>;
  abstract updateConsent(params: DataConsentModel): Observable<ConsentModel>;
  abstract deleteConsent(params: { id: string }): Observable<ConsentModel>;

  /** Empresa */
  abstract getTypeBusiness(): Observable<TypeBusinessModel>;
  abstract getBusinessAll(): Observable<BusinessModel<DataBusinessModel[]>>;
  abstract getBusinessById(): Observable<BusinessModel>;
  abstract insertBusiness(params: DataBusinessModel): Observable<BusinessModel>;
  abstract updateBusiness(params: DataBusinessModel): Observable<BusinessModel>;
  abstract updateLogoBusiness(params: DataBusinessModel): Observable<BusinessModel>;
  abstract insertDemoBusiness(params: DataDemoBusinessModel): Observable<DemoBusinessModel>;

  /** Empresa Admin */
  abstract getBusinessByPaged(params: {PageNumber:number,PageSize:number, Search:string}):Observable<BusinessModel<DataBusinessModel[]>>;
  abstract getBusinessByIdAdmin(params:{idEmpresa:string}): Observable<BusinessModel>;
  
  /** Cargos */
  abstract insertCollaboratorPosition(params: DataCollaboratorPositionEntity): Observable<CollaboratorPositionModel>;
  abstract updateCollaboratorPosition(params: DataCollaboratorPositionEntity): Observable<CollaboratorPositionModel>;
  abstract getCollaboratorPosition(params: { idColaboradorEmpresa: string }): Observable<CollaboratorPositionModel>;
  
  /**Agendamiento */
  abstract insertScheduleProfessional( params: DataScheduleProfessionalModel[]): Observable<ScheduleProfessionalModel>;
  abstract updateScheduleProfessional( params: DataScheduleProfessionalModel[]): Observable<ScheduleProfessionalModel>;
  abstract getScheduleProfessionalByIdConpany( params: DataScheduleProfessionalModel): Observable<ScheduleProfessionalModel>;
  
  /** Documentos del sistema */
  abstract getDocumentsSystem():Observable<DocumentsSystemModel>;
  abstract createDocumentSystem(params: DataDocumentsSystemModel): Observable<DocumentsSystemModel>;
  abstract updateDocumentsSystem(params: DataDocumentsSystemModel):Observable<DocumentsSystemModel>;
  abstract getFileDocumentsSystem(): Observable<FileDocumentsSystemModel>;
  abstract createFileDocumentsSystem( params: DataFileDocumentsSystemModel):Observable<FileDocumentsSystemModel>;
  abstract updateFileDocumentsSystem( params: DataFileDocumentsSystemModel): Observable<FileDocumentsSystemModel>;
  abstract getFileDocumentsSystemById( params: DataFileDocumentsSystemModel): Observable<FileDocumentsSystemModel>;
  abstract getChannelSend(): Observable<ChannelSendModel>;
  abstract createChannelSend( params: DataChannelSendModel ):Observable<ChannelSendModel>;
  abstract updateChannelSend( params: DataChannelSendModel ):Observable<ChannelSendModel>;
  
  /** Menu del sistema */
  abstract getAllMenu():Observable<MenuModel>;
  abstract insertmenu( params: DataMenuModel): Observable<MenuModel>;
  abstract updatemenu( params: DataMenuModel): Observable<MenuModel>;

  /** Perfiles del sistema */
  abstract getAllPerfil():Observable<PerfilModel>;
  abstract insertperfil(params: DataPerfilModel):Observable<PerfilModel>;
  abstract updateperfil( params: DataPerfilModel ): Observable<PerfilModel>;
  abstract getAllPerfilMenu(): Observable<PerfilMenuModel>;
  abstract insertPerfilMenu(params: DataPerfilMenuModel): Observable<PerfilMenuModel>;
  abstract deletePerfilMenu(params: DataPerfilMenuModel): Observable<PerfilMenuModel>;
  abstract getAllPerfilMenuById(params: DataPerfilMenuModel): Observable<PerfilMenuModel>;

}